// @flow
import env from "../../etc/env";

const { API_URL } = env;

// General GET, POST, PUT, DELETE helpers can help abstract subtleties from
// your http client library of choice. Can be stored in api/index.js
const get = (path: string): Promise<string> =>
  // Skipping Content-Type checks for brevity
  fetch(`${API_URL}/${path}`).then(result => result.text());

// It's helpful to abstract any API-related logic into helpers away from your
// components. Can be organized by entity === filename or similar.
const getLightboxDescription = () =>
  get("?type=all-meat&sentences=1&start-with-lorem=1&format=text");

export default getLightboxDescription;



// WEBPACK FOOTER //
// ./src/helpers/api/lightbox.js